/**
 * Handling the nav icon
 * */

(function($) {

    /**
     * Add menu target class to head
     *
     * */
    $('html').addClass('menu-target');

     $('.toggle-panel').click( function(e){

        e.stopPropagation();

        if($('#fixed-nav').hasClass('menu-open')){

            $('.menu-target').removeClass('menu-open');

        }else{
            $('.menu-target').addClass('menu-open');

        }
    });
    $('.page-wrap').click( function(){
        if($('#fixed-nav').hasClass('menu-open')){

            $('.menu-target').removeClass('menu-open');

        }
    });


    /**
     * On resize remove all open references
     * */
    $(window).resize( function(){
        $('.menu-target').removeClass('menu-open');
    })
 })( jQuery );

